export default function sleep(timeout: number): Promise<void> {
  return new Promise<void>((resolve) => {
    window.setTimeout(() => {
      resolve()
    }, timeout)
  })
}
